import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

// An Amazon DSP advertiser, plus the Trellis org it is onboarded to or suggested for. Mirrors
// DSPProfileRepo.get_dsp_profile_association_summary in app-rest-api.
const dspProfileSchema = z.object({
  name: z.string(),
  dsp_profile_name: z.string(),
  dsp_advertiser_id: z.string(),
  // Amazon omits it for some advertisers.
  country: z.string().optional(),
  currency: z.string().nullish(),
  url: z.string(),
  store_page_id: z.string().nullable(),
  client_id: z.number(),
  dsp_client_account_id: z.string(),
  dsp_client_name: z.string(),
  onboarded: z.boolean(),
  onboarded_org_id: z.number().nullable(),
  onboarded_org_name: z.string().nullable(),
  suggested_org_id: z.number().nullable(),
  suggested_org_name: z.string().nullable(),
});

export type DSPProfile = z.infer<typeof dspProfileSchema>;

export const dspProfileApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "getDSPProfileAssociations",
    method: "get",
    path: "/dsp/profiles/",
    parameters: [
      { name: "include_associations", type: "Query", schema: z.literal(true) },
      { name: "marketplace", type: "Query", schema: z.string() },
      // Bypasses the backend's cache and re-fetches the advertisers from Amazon.
      { name: "refresh", type: "Query", schema: z.literal(true).optional() },
    ],
    status: 200,
    response: z.object({ data: z.array(dspProfileSchema) }),
  })
    .addEndpoint({
      alias: "onboardDSPProfile",
      method: "post",
      path: "/dsp/profiles/",
      parameters: [
        {
          name: "body",
          type: "Body",
          schema: z.object({
            dsp_advertiser_id: z.string(),
            destination_org: z.number(),
            dsp_client_id: z.number(),
            // The backend falls back to US when it is missing.
            marketplace: z.string().optional(),
          }),
        },
      ],
      status: 201,
      response: z.unknown(),
    })
    .build(),
);
